import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AbstractAuthGuard } from '@services/abstract/abstract.auth.guard';
import { AuthService } from '@services/auth/auth.service';

@Injectable()
export class UserGuard extends AbstractAuthGuard {
  constructor(
    protected authService: AuthService,
    protected router: Router,
    protected navCtrl: NavController,
  ) {
    super(authService, router);
  }

  protected check(user): boolean {
    if (!user) {
      this.navCtrl.navigateRoot('/public');
      return false;
    }

    return true;
  }

  protected onError(e): boolean {
    return false;
  }
}
